<div class="detail-sf36">
  <div class="data-chart mb-6">
    <div class="mb-5 ms-xxl-6 me-xxl-4">
      <h1 class="fs-2 me-3 my-1">
        <ng-container
          *appSkeletonLoader="
            loading;
            style: { height: '2.5rem', width: '10rem' }
          "
        >
          <span i18n="@@patient_evaluationSF36_title"
            >36-Item Abbreviated Survey Instrument (SF-36)</span
          >
        </ng-container>
      </h1>
    </div>
    <ng-container *appSkeletonLoader="loading; style: { height: '5rem' }">
      <div class="mb-6 ms-xxl-4 me-xxl-4 data-chart__filters p-4">
        <div class="container-fluid">
          <div class="row align-items-center mb-4">
            <div class="col-12 col-xl-6 mb-4 mb-xl-0">
              <h4 class="text-uppercase d-flex align-items-center mb-0">
                <img
                  src="assets/icons/icon-filters.svg"
                  class="img-fluid me-3"
                />
                <span i18n="@@patient_evaluationSF36_customizedDatesDisplay"
                  >Dates (applied to all dimensions)</span
                >
              </h4>
            </div>
            <div class="col-12 col-xl-6 mb-4">
              <form [formGroup]="dateRangeForm">
                <div
                  class="data-chart__filter row align-items-center my-1 justify-content-end"
                >
                  <div class="col-auto pe-0">
                    <ng-container
                      *appSkeletonLoader="
                        loading;
                        style: { height: '2.5rem', width: '1.8rem' }
                      "
                    >
                      <label
                        for="startDate"
                        class="col-form-label fw-semi-bold text-gray-70"
                        i18n="@@patient_evaluation_fromLabel"
                        >From</label
                      >
                    </ng-container>
                  </div>
                  <div class="col-auto">
                    <div class="form-group">
                      <ng-container
                        *appSkeletonLoader="
                          loading;
                          style: { height: '2.5rem', width: '8rem' }
                        "
                      >
                        <div
                          class="input-group"
                          ngbDropdown
                          #dropdownStartDate="ngbDropdown"
                          autoClose="outside"
                          placement="bottom-right"
                        >
                          <input
                            type="text"
                            class="form-control form-control--monthpicker bg-white"
                            placeholder="MM/AAAA"
                            i18-placeholder="@@patient_evaluation_fromPlaceholder"
                            name="startDate"
                            formControlName="startDate"
                            [ngClass]="{
                              'border-danger':
                                dateRangeForm.get('startDate').invalid &&
                                !dateRangeForm.get('startDate').pristine
                            }"
                          />
                          <button
                            type="button"
                            class="dropdown-toggle-split"
                            id="dropdownStartDate"
                            [ngClass]="{
                              'border-danger':
                                dateRangeForm.get('startDate').invalid &&
                                !dateRangeForm.get('startDate').pristine
                            }"
                            ngbDropdownToggle
                          >
                            <img
                              src="assets/icons/icon_calendar.svg"
                              class="img-fluid"
                              alt="calendar"
                            />
                          </button>
                          <div
                            ngbDropdownMenu
                            class="p-0"
                            aria-labelledby="dropdownStartDate"
                          >
                            <app-monthpicker
                              (selected)="
                                changeDateRange($event, 'startDate');
                                dropdownStartDate.close()
                              "
                              [year]="getDateYear('startDate')"
                              [month]="getDateMonth('startDate')"
                            ></app-monthpicker>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="col-auto px-0">
                    <ng-container
                      *appSkeletonLoader="
                        loading;
                        style: { height: '2.5rem', width: '1.8rem' }
                      "
                    >
                      <label
                        for="endDate"
                        class="col-form-label fw-semi-bold text-gray-70"
                        i18n="@@patient_evaluation_toLabel"
                      >
                        to</label
                      >
                    </ng-container>
                  </div>
                  <div class="col-auto">
                    <div class="form-group">
                      <ng-container
                        *appSkeletonLoader="
                          loading;
                          style: { height: '2.5rem', width: '7rem' }
                        "
                      >
                        <div
                          class="input-group"
                          ngbDropdown
                          #dropdownEndDate="ngbDropdown"
                          autoClose="outside"
                          placement="bottom-right"
                        >
                          <input
                            class="form-control form-control--monthpicker bg-white"
                            placeholder="MM/AAAA"
                            i18-placeholder="@@patient_evaluation_toPlaceholder"
                            id="endDate"
                            formControlName="endDate"
                            [ngClass]="{
                              'border-danger':
                                dateRangeForm.get('endDate').invalid &&
                                !dateRangeForm.get('endDate').pristine
                            }"
                          />
                          <button
                            type="button"
                            class="dropdown-toggle-split"
                            id="dropdownEndDate"
                            [ngClass]="{
                              'border-danger':
                                dateRangeForm.get('endDate').invalid &&
                                !dateRangeForm.get('endDate').pristine
                            }"
                            ngbDropdownToggle
                          >
                            <img
                              src="assets/icons/icon_calendar.svg"
                              class="img-fluid"
                              alt="calendar"
                            />
                          </button>
                          <div
                            ngbDropdownMenu
                            class="p-0"
                            aria-labelledby="dropdownEndDate"
                          >
                            <app-monthpicker
                              (selected)="
                                changeDateRange($event, 'endDate');
                                dropdownEndDate.close()
                              "
                              [year]="getDateYear('endDate')"
                              [month]="getDateMonth('endDate')"
                            ></app-monthpicker>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-4">
              <h4 class="text-uppercase d-flex align-items-center mb-0">
                <img
                  src="assets/icons/icon-filters.svg"
                  class="img-fluid me-3"
                />
                <span i18n="@@patient_evaluationSF36_dimensionDisplay"
                  >Dimension display</span
                >
                ({{ getDisplayedDimensions() }})
              </h4>
            </div>
            <div class="col-12">
              <div class="row mt-4 row-cols-1">
                <div
                  class="col-12 col-xl-6"
                  *ngFor="let item of evaluations | keyvalue; let i = index"
                >
                  <div
                    *ngIf="
                      item['key'] !== 'sf36PhysicalHealth' &&
                      item['key'] !== 'sf36MentalHealth'
                    "
                    class="btn-group btn-group-toggle form-group checkbox-group"
                  >
                    <div class="d-flex align-items-start">
                      <label
                        class="checkbox-form btn"
                        ngbButtonLabel
                        [class.active]="!item.value.hidden"
                      >
                        <input
                          type="checkbox"
                          [ngModel]="!item.value.hidden"
                          (ngModelChange)="toggleHideDimension($event, item.key)"
                          [id]="'dimensionFilterOption_' + i"
                        />
                          {{ item.value.title }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngFor="let evaluation of evaluations | keyvalue; let i = index"
    >
      <div
        *ngIf="
          evaluation['key'] !== 'sf36PhysicalHealth' &&
          evaluation['key'] !== 'sf36MentalHealth'
        "
        class="data-chart"
        [ngClass]="{ 'mt-3': i > 0, 'd-none': evaluation.value.hidden }"
      >
        <h2 class="fs-4 mb-3 ms-xxl-6">
          <ng-container
            *appSkeletonLoader="loading; style: { height: '2.5rem' }"
          >
            {{ evaluation["value"]["title"] }}
          </ng-container>
        </h2>
        <app-chart
          [loading]="loadingChart"
          [chartType]="'bar'"
          [chartDatasets]="datasets[evaluation['key']]"
          [chartXLabels]="xLabels[evaluation['key']]"
          [chartHorizontalLimitLines]="
            evaluation['value']['horizontalLimitLines']
          "
          [hasInteractiveLegend]="false"
        ></app-chart>
      </div>
    </ng-container>
    <div class="py-4 ms-xxl-6 me-xxl-4">
      <ngb-accordion #a="ngbAccordion" activeIds="desc_about, desc_situation">
        <ngb-panel id="desc_about">
          <ng-template ngbPanelHeader>
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="m-0">
                <ng-container
                  *appSkeletonLoader="
                    loading;
                    style: { height: '1.6rem', width: '10rem' }
                  "
                >
                  <span i18n="@@patient_evaluation_aboutTitle">About</span>
                </ng-container>
              </h3>
              <div>
                <ng-container
                  *appSkeletonLoader="
                    loading;
                    type: 'circle';
                    style: { height: '2.6rem', width: '2.6rem' }
                  "
                >
                  <button ngbPanelToggle class="btn btn-link p-0">
                    <img
                      [src]="
                        a.isExpanded('desc_about')
                          ? 'assets/icons/icon-dropdown-close.svg'
                          : 'assets/icons/icon-dropdown-open.svg'
                      "
                      alt="icon"
                    />
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="content-card">
              <ng-container
                *appSkeletonLoader="loading; style: { height: '12rem' }"
              >
                <div>
                  <p i18n="@@patient_evaluationSF36_aboutContent">
                    Ce questionnaire est une échelle multidimensionnelle qui
                    permet d'évaluer la qualité de vie liée à la santé.
                  </p>
                  <p
                    i18n="@@patient_evaluationSF36_aboutContentTitle"
                    class="mt-5"
                  >
                    Cette échelle évalue 8 dimensions :
                  </p>
                  <ul class="list mt-5">
                    <li>
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li1"
                        >Activité physique :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li1"
                        >La mesure dans laquelle la santé limite les activités
                        physiques comme les soins personnels, la marche, la
                        montée de côtes et d&apos;escaliers, le fait de se
                        pencher, de soulever des charges, et les activités
                        modérées et activités intenses</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li2"
                        >Limitations dues à l'état physique :</b
                      >

                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li2"
                        >Limitations des activités au cours des 4 dernières
                        semaines, telles que moins de temps consacré aux
                        activités, limité dans le type de travail, ayant des
                        difficultés ou accomplissant moins que souhaité</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li3"
                        >Douleurs physiques :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li3"
                        >Importance de la douleur qui a un impact sur les
                        activités quotidiennes (y compris le travail et les
                        tâches ménagères)</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li4"
                        >Santé générale :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li4"
                        >Évaluation de la santé actuelle, de la santé future et
                        de la résistance aux maladies</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li5"
                        >Vitalité :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li5"
                        >Durée au cours du dernier mois où la personne s'est
                        sentie plein de vitalité, épuisée.</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li6"
                        >Fonctionnement social :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li6"
                        >La mesure dans laquelle la santé physique ou les
                        problèmes émotionnels limitent les activités sociales
                        normales</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li7"
                        >Limitations dues à l'état émotionnel:</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li7"
                        >mesure la gêne due aux problèmes psychiques dans les
                        activités quotidiennes: temps passé au travail moins
                        important, travail baclé.</span
                      >
                    </li>
                    <li class="mt-5">
                      <b i18n="@@patient_evaluationSF36_aboutContentTitle2Li8"
                        >Santé psychique :</b
                      >
                      <span
                        i18n="
                          @@patient_evaluationSF36_aboutContentDescription2Li8"
                        >Durée au cours du dernier mois où la personne s'est
                        sentie très nerveuse, abattue ; heureuse, calme et
                        paisible</span
                      >
                    </li>
                    <br />
                    <!-- <li class="mt-5"> -->
                    <!-- <b
                      i18n="@@patient_evaluationSF36_aboutContentTitleCopyright"
                      >Copyright :</b
                    >
                    <br /> -->
                    <span
                      i18n="
                        @@patient_evaluationSF36_aboutContentDescriptionCopyright"
                      >36-Item Short Form Health Survey developed by RAND as
                      part of the Medical Outcomes Study. Changes made for
                      digital adaptation.</span
                    >
                    <!-- </li> -->
                  </ul>
                </div>
                <div class="mt-4">
                  <a
                    href="assets/documents/surveys/sf36-{{ locale }}.pdf"
                    alt="sf36"
                    target="_blank"
                  >
                    <span
                      class="text-light fw-medium"
                      i18n="@@patient_evaluation_aboutSurveyFile"
                      >Show survey</span
                    ><span
                      class="link-icon d-inline-block p-3 rounded-3 bg-white me-3"
                    >
                      <img src="assets/img/icon-pdf.svg" class="img-fluid" />
                    </span>
                  </a>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="desc_situation">
          <ng-template ngbPanelHeader let-opened="opened">
            <div
              class="d-flex align-items-center justify-content-between line-top"
            >
              <h3 class="m-0">
                <ng-container
                  *appSkeletonLoader="
                    loadingChart;
                    style: { height: '1.6rem', width: '10rem' }
                  "
                >
                  <span i18n="@@patient_evaluation_descriptionSituationTitle"
                    >Situation description</span
                  >
                </ng-container>
              </h3>
              <div>
                <ng-container
                  *appSkeletonLoader="
                    loadingChart;
                    type: 'circle';
                    style: { height: '2.6rem', width: '2.6rem' }
                  "
                >
                  <button ngbPanelToggle class="btn btn-link p-0">
                    <img
                      [src]="
                        a.isExpanded('desc_situation')
                          ? 'assets/icons/icon-dropdown-close.svg'
                          : 'assets/icons/icon-dropdown-open.svg'
                      "
                      alt="icon"
                    />
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="content-card">
              <ng-container
                *appSkeletonLoader="loadingChart; style: { height: '12rem' }"
              >
                <div>
                  <p
                    i18n="
                      @@patient_evaluationSF36_situationDescriptionContentP1"
                  >
                    Toutes les questions sont notées sur une échelle de 0 à 100,
                    100 représentant le plus haut niveau de fonctionnement
                    possible. Les scores globaux sont calculés en pourcentage du
                    total des points possibles, à l'aide d'une table de
                    correspondance spécifique.<br />
                    Les scores des questions qui traitent de chaque domaine
                    spécifique de l'état de santé fonctionnel sont ensuite
                    moyennés ensemble, pour obtenir un score final dans chacune
                    des 8 dimensions.
                  </p>
                  <p
                    class="mt-5"
                    i18n="
                      @@patient_evaluationSF36_situationDescriptionContentP2"
                  >
                    Le Score Moyen Physique (Physical Component Summary - PCS)
                    est un score résumé des 8 dimensions pondérant positivement
                    les 4 sous-échelles physiques (Activité Physique,
                    Limitations dues à l'État Physique, Douleurs Physiques et
                    Santé Générale).
                  </p>

                  <p class="mt-5">
                    <ng-container
                      i18n="@@questionnaires_patientStatusSummaryIntro"
                      >Entre le
                      <strong>
                        {{ dateRangeForm.get("startDate").value }}
                      </strong>
                      et le
                      <strong>
                        {{ dateRangeForm.get("endDate").value }}
                      </strong>
                      <strong>{{
                        patientProfile.firstName + " " + patientProfile.lastName
                          | uppercase
                      }}</strong>
                      a rempli
                      <strong> {{ measuringPointsTotal }} </strong>
                      questionnaires.
                    </ng-container>
                  </p>
                  <p
                    class="mt-5"
                    i18n="
                      @@patient_evaluationSF36_situationDescriptionContentP5"
                  >
                    Pour les Score Moyen Physique et Score Moyen Mental, les
                    résultats du questionnaire montrent que durant cette
                    période, il y a eu une évolution de :
                  </p>
                  <ul class="list">
                    <li>
                      <b>{{ progressions["sf36PhysicalHealth"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi1"
                        >dans l'ensemble des aspects physiques du patient (Score
                        Moyen Physique)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf36MentalHealth"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi2"
                        >dans l'ensemble des aspects mentales du patient (Score
                        Moyen Mental)</span
                      >
                    </li>
                  </ul>
                  <p
                    class="mt-5"
                    i18n="@@patient_evaluationSF36_situationDescriptionLiTitle"
                  >
                    Par rapport aux 8 dimensions, les résultats du questionnaire
                    montrent que durant cette période, il y a eu une évolution
                    de :
                  </p>
                  <ul class="list">
                    <li>
                      <b>{{ progressions["sf361"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi3"
                        >dans l'ensemble du fonctionnement physique du patient
                        (Activité Physique)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf363"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi4"
                        >dans le niveau de gêne du patient dans ses activités
                        quotidiennes associé à son état physique (Limitations
                        dues à l'État Physique)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf365"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi5"
                        >dans le niveau d'intensité de la douleur ressentie par
                        le patient (Douleurs Physiques)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf367"] }} </b
                      ><span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi6"
                        >dans de l'état de santé général du patient (Santé
                        Générale)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf362"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi7"
                        >sur le niveau d'énergie du patient (Vitalité)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf364"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi8"
                        >sur le niveau de limitations du patient dans ses
                        activités sociales en raison de problèmes de santé
                        physiques et psychologiques (Fonctionnement
                        Social)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf366"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi9"
                        >dans le niveau de gêne du patient dans ses activités
                        quotidiennes associé à des problèmes psychologiques
                        (Limitations dues à l'État Émotionnel)</span
                      >
                    </li>
                    <li>
                      <b>{{ progressions["sf368"] }} </b>
                      <span
                        i18n="@@patient_evaluationSF36_situationDescriptionLi10"
                        >de la santé mentale globale du patient (Santé
                        Psychique)</span
                      >
                    </li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
</div>
